import pino from "pino"
import { consoleLogWriterConfig, getOtelTraceContext, logLevelLabels, logLevels } from "./logger-utils"
import { emitBrowserOtelLog } from "../telemetry/otel-logs"

// Min log level
const minLevelLabel = logLevelLabels.info

export default function DevLogger() {
  return pino({
    level: minLevelLabel,
    customLevels: logLevels,
    useOnlyCustomLevels: true,
    // timestamp: pino.stdTimeFunctions.isoTime(),
    enabled: true,
    mixin: getOtelTraceContext,
    browser: {
      asObject: true,
      disabled: false,
      serialize: true,
      formatters: {
        level: (label, number) => {
          return { level: number, label }
        },
      },
      write: consoleLogWriterConfig(minLevelLabel),
      transmit: {
        level: minLevelLabel,
        send: (level, logEvent) => {
          const bindings = logEvent.bindings?.reduce((acc, b) => Object.assign(acc, b), {}) ?? {}
          const extraAttrs = { 'log.source': 'pino' }
          if (bindings.module) extraAttrs['log.module'] = bindings.module
          emitBrowserOtelLog(level, logEvent.messages, extraAttrs)
        },
      },
    },
  })
}
